import { render, staticRenderFns } from "./I2FormVueSelect.vue?vue&type=template&id=0a04e3c4"
import script from "./I2FormVueSelect.vue?vue&type=script&lang=js"
export * from "./I2FormVueSelect.vue?vue&type=script&lang=js"
import style0 from "./I2FormVueSelect.vue?vue&type=style&index=0&id=0a04e3c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports